import DOMPurify from "dompurify";

// Force a safe rel on any link that opens in a new tab — prevents reverse
// tab-nabbing (the new page can't reach window.opener).
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

// Central HTML sanitizer used everywhere we render HTML strings (chat markdown,
// email-template previews, rich-text editor content). DOMPurify's defaults strip
// <script>, event handlers (onerror/onclick…) and javascript: URLs while keeping
// safe markup and the inline styles/tables email previews rely on.
export const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html || "", { ADD_ATTR: ["target"] });

export default sanitizeHtml;
